import { createApp } from 'vue';
import App from './App.vue';
import { store } from './store';
import router from './router';

const app = createApp(App).use(store).use(router);
Object.values(import.meta.globEager('/src/modules/*.ts')).forEach(module => module.install?.(app));

app.mount('#app');
